import { OrganismeFormeJuridique } from '@common/services';

export const ORGANISME_FORME_JURIDIQUE_TEXTS: Record<OrganismeFormeJuridique, string> = {
  [OrganismeFormeJuridique.EI]: 'Entreprise individuelle (EI)',
  [OrganismeFormeJuridique.EURL]: 'Entreprise unipersonnelle à responsabilité limitée (EURL)',
  [OrganismeFormeJuridique.SARL]: 'Société à responsabilité limitée (SARL)',
  [OrganismeFormeJuridique.SA]: 'Société anonyme (SA)',
  [OrganismeFormeJuridique.SAS]: 'Société par actions simplifiée (SAS)',
  [OrganismeFormeJuridique.SASU]: 'Société par actions simplifiée unipersonnelle (SASU)',
  [OrganismeFormeJuridique.SNC]: 'Société en nom collectif (SNC)',
  [OrganismeFormeJuridique.SCOP]: 'Société coopérative de production (SCOP)',
  [OrganismeFormeJuridique.ASSOCIATION]: 'Association',
  [OrganismeFormeJuridique.CONSULAIRE]: 'Consulaire',
  [OrganismeFormeJuridique.STRUCTPUB]: 'Structure publique',
  [OrganismeFormeJuridique.AUTRE]: 'Autre structure privée',
};